import { privateHttp } from "@/shared/http/private-http";

/** Estado do "Avise-me quando chegar" do cliente para um produto/loja. */
export interface StockAlertStatus {
    productId: number;
    storeId: number;
    active: boolean;
    dateAdded: string | null;
}

/** POST /products/:productId/stock-alert — pede (ou reativa) o aviso. Requer login. */
export async function requestStockAlert(
    productId: number,
    storeId: number
): Promise<StockAlertStatus> {
    const { data } = await privateHttp.post<StockAlertStatus>(
        `/products/${productId}/stock-alert`,
        undefined,
        { params: { storeId } }
    );
    return data;
}

/** DELETE /products/:productId/stock-alert — cancela o aviso. Requer login. */
export async function cancelStockAlert(
    productId: number,
    storeId: number
): Promise<StockAlertStatus> {
    const { data } = await privateHttp.delete<StockAlertStatus>(
        `/products/${productId}/stock-alert`,
        { params: { storeId } }
    );
    return data;
}

/** GET /products/:productId/stock-alert — estado atual do aviso. Requer login. */
export async function getStockAlertStatus(
    productId: number,
    storeId: number
): Promise<StockAlertStatus> {
    const { data } = await privateHttp.get<StockAlertStatus>(`/products/${productId}/stock-alert`, {
        params: { storeId },
    });
    return data;
}
